import { useState, useEffect } from "react";
import { Button, Form, Row, Col, Input, message } from "antd";
import FormLayout, {
  FormContent,
  FormFooter,
  FormHeader,
} from "../../../components/form/form";
import { FormRow } from "../../../components/form/form-row";
import styles from "./utility.module.css";
import TextArea from "antd/es/input/TextArea";
import { CopyOutlined } from "@ant-design/icons";
import EncryptUtils from "../../../utils/encrypt";

export default function EncDecUtility() {
  const [form] = Form.useForm();
  const [decryptedValue, setDecryptedValue] = useState();
  const [encryptedValue, setEncryptedValue] = useState();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const correctPassword = "Web@nix@123"; // Change this to the desired password

  const handleCopy = async () => {
    try {
      const decryptedValue = form.getFieldValue("decryptedOutput");
      await navigator.clipboard.writeText(decryptedValue);
      message.success("Decrypted value copied to clipboard");
    } catch (err) {
      message.error("Failed to copy");
    }
  };

  return (
    <FormLayout>
      {!isAuthenticated ? (
        <div
          style={{
            height: "400px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <h3>Enter Password to Access</h3>
            <Input.Password
              placeholder="Enter Password"
              onChange={(e) => setPassword(e.target.value)}
              onPressEnter={() =>
                setIsAuthenticated(password === correctPassword)
              }
            />
            <Button
              style={{ marginTop: 10 }}
              type="primary"
              onClick={() => setIsAuthenticated(password === correctPassword)}
            >
              Submit
            </Button>
          </div>
        </div>
      ) : (
        <Form form={form} name="register" layout="vertical">
          <FormHeader className={styles.headerStyle}>
            Advance Utility
          </FormHeader>
          <FormContent className={styles.contentStyle}>
            <Row gutter={16} className="formRowHeight">
              <Col span={10}>
                <Form.Item
                  name="encryptedInput"
                  label={
                    <span className={styles.customLabel}>Encrypted Value</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please enter value to be decrypted",
                    },
                  ]}
                >
                  <TextArea
                    rows={4}
                    placeholder="Enter the encrypted value..."
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Button
                  style={{ marginTop: "4rem" }}
                  onClick={() => {
                    const encryptedValue = form.getFieldValue("encryptedInput");
                    const decryptValue = EncryptUtils.decrypt(encryptedValue);

                    setDecryptedValue(decryptValue as any);
                    form.setFieldValue("decryptedOutput", decryptValue);
                  }}
                  type="primary"
                >
                  Decrypt
                </Button>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="decryptedOutput"
                  label={
                    <span className={styles.customLabel}>Decrypted Value</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please choose service partner",
                    },
                  ]}
                >
                  <TextArea
                    value={decryptedValue}
                    readOnly
                    rows={4}
                    placeholder="Get the decrypted value..."
                  />
                  <Button icon={<CopyOutlined />} onClick={handleCopy}>
                    Copy
                  </Button>
                </Form.Item>
              </Col>

              <Col span={10}>
                <Form.Item
                  name="decryptedInput"
                  label={
                    <span className={styles.customLabel}>Decrypted Value</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please enter value to be encrypted",
                    },
                  ]}
                >
                  <TextArea rows={4} placeholder="Enter the reason..." />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Button
                  style={{ marginTop: "4rem" }}
                  onClick={() => {
                    const decryptedInput = form.getFieldValue("decryptedInput");
                    const encryptedValue = EncryptUtils.encrypt(decryptedInput);

                    setEncryptedValue(encryptedValue as any);
                    form.setFieldValue("encryptedOutput", encryptedValue);
                  }}
                  type="primary"
                >
                  Encrypt
                </Button>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="encryptedOutput"
                  label={
                    <span className={styles.customLabel}>Encrypted Value</span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please enter encrypted string",
                    },
                  ]}
                >
                  <TextArea
                    value={encryptedValue}
                    readOnly
                    rows={4}
                    placeholder="Get the encrypted value..."
                  />
                </Form.Item>
              </Col>
            </Row>
          </FormContent>
          <FormFooter className={styles.footerStyle}>
            <FormRow>
              <></>
            </FormRow>
          </FormFooter>
        </Form>
      )}
    </FormLayout>
  );
}
